module.exports = __webpack_public_path__ + "media/images/icon_sort_btn_comment_on-9f1084b51627a245259ecdedad25c199.png";